import React, {Fragment} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";
import {swalConfirm, swalError, swalLoading, swalSuccess, swal} from "../../../../../helpers/SweetAlertWrapper";

export default class TimeoffRequestDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStatusLabel = status => {
        switch (status) {
            case "approved":
                return {label: "Approvato", className: "badge badge-success"};
            case "rejected":
                return {label: "Rifiutato", className: "badge badge-danger"};
            case "waiting_approval":
            default:
                return {label: "In attesa", className: "badge badge-warning"};
        }
    }

    handleDeleteClick = _ => {
        if (!this.props.onDelete) return;
        swalConfirm("Vuoi eliminare questa richiesta di permesso?")
            .then(_ => {
                swalLoading();
                return this.props.onDelete(this.props.request)
                    .then(() => {
                        swal.safeClose();
                        swalSuccess("Richiesta eliminata");
                        this.props.onDismiss();
                    })
                    .catch(error => {
                        swal.safeClose();
                        swalError(error || "Non e' stato possibile eliminare la richiesta");
                    });
            })
            .catch(_ => null);
    }

    renderAttachments = count => {
        if (!count || count <= 0) {
            return <div className={"text-muted small"}>Nessun allegato</div>;
        }
        const items = [...Array(count)].map((_, index) => {
            return (
                <li key={index} className={"list-group-item small"}>
                    Allegato {index + 1}
                </li>
            );
        });
        return <ul className={"list-group"}>{items}</ul>;
    }

    render() {
        const request = this.props.request || {};
        const staff = this.props.staff || {};
        const negozio = staff.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        const statusInfo = this.getStatusLabel(request.status);
        const formattedDate = request.date ? moment(request.date).format("DD/MM/YYYY") : "-";
        const timeRange = request.start_time && request.end_time ? `${request.start_time} - ${request.end_time}` : "-";

        return (
            <Fragment>
                <Page
                    title={"Dettaglio richiesta"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    content={
                        <div className={"container py-3"}>
                            <div className={"d-flex justify-content-between align-items-start"}>
                                <div className={"d-flex align-items-center"}>
                                    <AppIconThumbnail size={"36px"} src={negozioIconUrl} className={"mr-2"}/>
                                    <div>
                                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                                        <div className={"text-muted small"}>{formattedDate} &nbsp; {timeRange}</div>
                                    </div>
                                </div>
                                <span className={statusInfo.className}>{statusInfo.label}</span>
                            </div>

                            <div className={"mt-3"}>
                                <div className={"small text-muted"}>Motivazione</div>
                                <div>{request.reason || "-"}</div>
                            </div>

                            {
                                request.status_reason &&
                                <div className={"mt-3"}>
                                    <div className={"small text-muted"}>Esito</div>
                                    <div>{request.status_reason}</div>
                                </div>
                            }

                            <div className={"mt-3"}>
                                <div className={"small text-muted"}>Allegati</div>
                                {this.renderAttachments(request.attachments_count || 0)}
                            </div>

                            {
                                request.status === "waiting_approval" &&
                                <div className={"mt-4"}>
                                    <button
                                        type={"button"}
                                        className={"btn btn-outline-danger"}
                                        onClick={this.handleDeleteClick}
                                    >
                                        Elimina richiesta
                                    </button>
                                </div>
                            }
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

TimeoffRequestDetailPage.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    onDelete: PropTypes.func,
    request: PropTypes.object,
    staff: PropTypes.object
};
